<!-- Kept — the messages worth keeping, as entries in a field journal.

     Each row shows the first few words in English and the date it was written.
     Tapping opens the message large, with its print sheet. There is no add
     button here: writing happens where the sand is. -->
<template>
  <IonPage>
    <IonContent :fullscreen="true" class="kept">
      <div class="sheet">
        <header class="head">
          <h1>Kept</h1>
        </header>

        <ul v-if="rows.length" class="entries">
          <li v-for="m in rows" :key="m.id">
            <button type="button" @click="open(m)">
              <span class="words">{{ m.text }}</span>
              <span class="when">{{ stamp(m.createdAt) }} · {{ m.surface }}</span>
            </button>
          </li>
        </ul>

        <p v-else class="empty">
          Nothing kept yet. Anything you write can be kept from the writing screen.
        </p>
      </div>
    </IonContent>
  </IonPage>
</template>

<script setup>
import { computed } from 'vue';
import { IonPage, IonContent } from '@ionic/vue';
import { useRouter } from 'vue-router';
import { messages } from '../store.js';

const router = useRouter();

// Real rows only — the demo seed's negative ids are QA furniture, not keepsakes.
const rows = computed(() => messages.value.filter((m) => Number(m.id) > 0));

const open = (m) => router.push({ name: 'message-detail', params: { id: m.id } });

const stamp = (iso) => (iso
  ? new Date(iso).toLocaleDateString('en-AU', { day: 'numeric', month: 'long' })
  : '');
</script>

<style scoped>
.kept { --background: var(--fs-paper); }
.sheet {
  min-height: 100%; background: var(--fs-paper); color: var(--fs-ink);
  font-family: var(--fs-body);
  padding: calc(16px + env(safe-area-inset-top, 0px)) 0 calc(16px + env(safe-area-inset-bottom, 0px));
}
.head { padding: 0 20px; }
.head h1 { margin: 0; font-family: var(--fs-serif); font-style: italic; font-weight: 400; font-size: 28px; }
.entries { list-style: none; margin: 10px 0 0; padding: 0; }
.entries li + li { border-top: 1px solid color-mix(in srgb, var(--fs-sepia) 18%, transparent); }
.entries button {
  display: flex; flex-direction: column; gap: 3px; width: 100%;
  min-height: 60px; padding: 12px 20px; border: 0; background: transparent;
  text-align: left; cursor: pointer; font-family: var(--fs-body); color: var(--fs-ink);
}
.entries button:active { background: color-mix(in srgb, var(--fs-sepia) 10%, transparent); }
.words {
  font-family: var(--fs-serif); font-size: 19px; line-height: 1.25;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;
}
.when { font-size: 12px; letter-spacing: 0.06em; color: color-mix(in srgb, var(--fs-ink) 55%, transparent); }
.empty { margin: 24px 20px 0; font-size: 16px; line-height: 1.5; color: color-mix(in srgb, var(--fs-ink) 65%, transparent); }
</style>
